export default __webpack_public_path__ + "static/media/xandrttd-icon.6c2a3663.png";